import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { ConsentCheckbox } from '../ConsentCheckbox'
import { ConsentSection } from '../ConsentSection'
import { InfoPanel } from '../InfoPanel'
import { ConsentSectionFieldsProps } from '../types'

export function TeleconsultationInfoConsentSection({ consents, updateConsent }: ConsentSectionFieldsProps) {
  return (
    <ConsentSection title={t`Understanding Teleconsultation`} required>
      <InfoPanel title={t`Learn more about teleconsultation`} defaultOpen>
        <div className="flex flex-col gap-2">
          <p>
            <Trans>A teleconsultation is a remote medical consultation conducted via video. It allows you to:</Trans>
          </p>
          <ul className="m-0 list-disc pl-5">
            <li>
              <Trans>Consult a doctor without traveling</Trans>
            </li>
            <li>
              <Trans>Receive a prescription if necessary</Trans>
            </li>
            <li>
              <Trans>Be referred for an in-person consultation if needed</Trans>
            </li>
          </ul>
          <p className="italic">
            <Trans>Limitations: Some procedures (physical examination, samples) cannot be performed remotely.</Trans>
          </p>
        </div>
      </InfoPanel>
      <ConsentCheckbox
        name="informedAboutTeleconsultation"
        label={t`I have read and understood the information above`}
        checked={consents.informedAboutTeleconsultation}
        onChange={(checked) => updateConsent('informedAboutTeleconsultation', checked)}
        required
      />
    </ConsentSection>
  )
}
